import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import {IVehicleList  } from "../../../Pages/Vehicle/Ivehicle";
interface IVehicleReduxState extends IReduxState<IVehicleList[]> {
  searchResults: {
    data: any;
    isLoading: boolean;
  };
}

export const VehicleSlicer = createSlice({
  name: "Vehicle",
  initialState: {
    data: {},
    isLoading: false,
    searchResults: {
      data: null,
      isLoading: false,
    },
  } as IVehicleReduxState,
  reducers: {
    getVehicle: (state) => {
      state.isLoading = true;
    },
    successGetVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },

    // New actions for vehicle search
    getVehicleSearch: (state) => {
      state.searchResults.isLoading = true;
    },
    successGetVehicleSearch: (state, action) => {
      state.searchResults.isLoading = false;
      state.searchResults.data = action.payload;
    },
    failureGetVehicleSearch: (state, action) => {
      state.searchResults.isLoading = false;
      state.searchResults.data = null;
    },
  },
});

export const {
  getVehicle,
  failureGetVehicle,
  successGetVehicle,
  getVehicleSearch,
  successGetVehicleSearch,
  failureGetVehicleSearch,
} = VehicleSlicer.actions;

export default VehicleSlicer.reducer;
